import { render, staticRenderFns } from "./Inhalt.vue?vue&type=template&id=e95310ac&"
import script from "./Inhalt.vue?vue&type=script&lang=js&"
export * from "./Inhalt.vue?vue&type=script&lang=js&"
import style0 from "./Inhalt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports